import React, { memo } from "react";

const Error = () => {
  return <div>Restaurant not found</div>;
};

export const RestaurantError = memo(Error);
